/* eslint-disable */

var Analytics = require("./analytics");


/** @param {Object} data */
/** @returns {void} */
function LocationRequestHandler(data){
    Analytics.dispatch("150815: Stock at Address Successful", true);
}
Analytics.registerTrackingEvent("LOCATION_REQUEST", LocationRequestHandler);


/** @param {string} storeState postCodeCheck.storeState */
/** @param {string} state postCodeCheck.state */
/** @returns {void} */
function ProductAvailabilityHandler(storeState, state){
    Analytics.dispatch("150820: Product Availability Message", (storeState || "UNKNOWN") +"|" +(state || "UNKNOWN"));
}
Analytics.registerTrackingEvent("PRODUCT_AVAILABILITY", ProductAvailabilityHandler);


function FulfillmentMethodHandler(fulfillmentMethod){
  Analytics.dispatch("150820: Fulfillment Method", fulfillmentMethod);
}
Analytics.registerTrackingEvent("FULFILLMENT_METHOD", FulfillmentMethodHandler);


function DeliveryTimeslotHandler(deliveryTimeslot){
  Analytics.dispatch("150820: Delivery Timeslot", deliveryTimeslot);
}
Analytics.registerTrackingEvent("DELIVERY_TIMESLOT", DeliveryTimeslotHandler);


Analytics.registerTrackingEvent("POSTCODE_SEARCH_TYPE", function (isGeoCode) {
  Analytics.dispatch("150820: Postal Code Search Type", isGeoCode ? 'Geolocation' : 'Typed');
});


Analytics.registerTrackingEvent("POSTCODE_SEARCH_VALUE", function (val) {
  Analytics.dispatch("150820: Postal Code Search Value", val);
});


Analytics.registerTrackingEvent("POSTCODE_SEARCH_VALUE_TYPE", function (isPostCode) {
  Analytics.dispatch("150820: Postal Code Search Value Type", isPostCode ? 'Postal Code' : 'Town');
});


Analytics.registerTrackingEvent("MULTIPLE_DELIVERY_LOCATIONS", function() {
  Analytics.dispatch("150820: Multiple Postal Codes Attempted", true);
});

Analytics.registerTrackingEvent("DELIVERY_GRID", function(data) {
  Analytics.dispatch("150820: Delivery Timeslot", data);
});

Analytics.registerTrackingEvent("STORE_LOGIC_SELECT", function analyticsStoreLogicSelect(bucket, position, available) {
  // data format is <Bucket|PositionSelected|AvailablePositionsCount>
  var data = [bucket, position, available].join('|');
  Analytics.dispatch("storeLogic", data);
});
Analytics.registerTrackingEvent("LOCATION_STATE_ERROR", function(locationDescriptor) {
  Analytics.dispatch("locationchange", locationDescriptor, "locationerror");
});

Analytics.registerTrackingEvent("LOCATION_STATE_COMPLETE", function(locationDescriptor) {
  Analytics.dispatch("locationchange", locationDescriptor, "locationcomplete");
});

Analytics.registerTrackingEvent("AUTOMATIC_STOCK_CHECKER", function(postCode) {
  Analytics.dispatch("Auto Stock Check Postal Code", postCode, 'locationautocomplete');
});

Analytics.registerTrackingEvent('collectInStoreDisplayed', function () {
  Analytics.dispatch('collectInStoreDisplayed', true, 'collectInStoreDisplayed');
});
